import {
  Col,
  Footer,
  Row,
  Container,
  Breadcrumb,
  Stars,
  Typography,
} from 'darrius';

import { Header } from '../../components/atoms';
import { HeadContent, ProfileForm, ProfileMenu } from '../../components';

import { type IProfileTemplateProps } from './@interface';

import {
  ProfileCertification,
  ProfileRating,
  ProfileRecomendations,
  ProfileResume,
  ProfileServices,
} from './partials';
import { ProfileLocation } from './partials/ProfileLocation';

import styles from './ExternalProfileTemplate.module.scss';

export default function ProfileTemplate({
  profilePageProps,
  staticContent,
}: IProfileTemplateProps) {
  const {
    meta,
    mainSection,
    categorySlug,
    form,
    resume,
    services,
    location,
    certification,
    rating,
    recomendations,
    menu,
  } = profilePageProps;

  const { footerContent } = staticContent;

  return (
    <>
      <HeadContent
        metaTitle={meta.title}
        slug={categorySlug}
        metaDescription={meta.description}
        type="profiles:external"
      />

      <Header.Simple />

      <main
        className="profile-page external category-page"
        data-category-slug={categorySlug}
      >
        <Container className="main-section">
          <Row className="bottom-sm">
            <Col className="col-sm-12 col-md-7">
              <Breadcrumb breadcrumbs={mainSection.breadcrumbs.items} />

              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: mainSection.breadcrumbs.structuredData,
                }}
              />

              <Typography.Title size="4xl">
                {mainSection.title}
              </Typography.Title>
              {rating && (
                <section
                  className={`${styles['rating-resume']} center-items space-bottom space-top`}
                  id="rating-resume"
                >
                  <Stars
                    size="small"
                    rating={rating.total}
                    quantity={rating.quantity}
                    showText={true}
                  />

                  <Typography.Text>
                    {rating.quantity} avaliações
                  </Typography.Text>
                </section>
              )}
            </Col>
          </Row>
        </Container>

        <ProfileMenu menu={menu} />

        <Container className="space-top">
          <Row>
            <Col className={`${styles['main-area']} col-sm-12 col-md-6`}>
              <ProfileResume resume={resume} />
              <ProfileRating rating={rating} />
              <ProfileRecomendations
                recomendations={recomendations}
                rating={rating}
              />
              <ProfileServices services={services} />
              <ProfileCertification certification={certification} />
              <ProfileLocation location={location} />
            </Col>
            <Col className={`${styles['form-area']} col-sm-12 col-md-6`}>
              <ProfileForm
                name="profile-form"
                categoryTree={form.categoryTree}
              />
            </Col>
          </Row>
        </Container>
      </main>
      <Footer data={footerContent} />
    </>
  );
}
